<template>
    <div>
        <vvo v-slot="{ passes }">
            <div class="form-group row m-t-10">
                <div class="col-md-12">
                    <label>
                        <h6>
                            <trans>위젯 이름</trans>
                        </h6>
                    </label>
                    <valid-input :inputType="'text'" :NonStatus="true" :inputValue.sync="copySetting.title"
                        :rules="rules.DASHBOARD_WIDGET_ITEM_NAME_RULE" :classList="'form-control'">
                    </valid-input>
                </div>
            </div>

            <div class="form-group row m-t-10">
                <div class="col-md-12">
                    <label>
                        <h6>
                            <trans>계통 선택</trans>
                        </h6>
                    </label>
                    <select v-model="copySetting.sysNodeIdx" class="form-control" :disabled="isLoading">
                        <option :value="null">선택안함</option>
                        <option v-for="node in systemNodeList" :key="node.sysNodeIdx" :value="node.sysNodeIdx">
                            {{ node.text }}
                        </option>
                    </select>
                    <small v-if="isLoading" class="text-muted">계통 목록을 불러오는 중...</small>
                </div>
            </div>

            <div class="form-group row m-t-10">
                <div class="col-md-12">
                    <label class="checkbox-label">
                        <input type="checkbox" v-model="copySetting.useMoneyUnit" />
                        <span>금액에 원단위 표시 적용</span>
                    </label>
                    <small class="text-muted d-block">체크 시 금액에 원단위 표시를 적용합니다.</small>
                </div>
            </div>

            <div class="form-group row m-t-10">
                <div class="col-md-12">
                    <label class="checkbox-label">
                        <input type="checkbox" v-model="copySetting.showSelfSufficiency" />
                        <span>에너지 자립률 표시</span>
                    </label>
                    <small class="text-muted d-block">체크 시 에너지 자립률 정보를 표시합니다.</small>
                </div>
            </div>

            <div class="form-group row m-t-10">
                <div class="col-md-12">
                    <label class="checkbox-label">
                        <input type="checkbox" v-model="copySetting.showEnergyConsumption" />
                        <span>에너지 소비 현황 표시</span>
                    </label>
                    <small class="text-muted d-block">체크 시 에너지 소비 현황 정보를 표시합니다.</small>
                </div>
            </div>

            <div class="form-group row m-t-20">
                <div class="col-md-12 p-0">
                    <div slot="modal-footer" class="w-100">
                        <button type="button" class="btn btn-primary m-r-5 pull-right" @click="passes(onModalOK())">
                            <trans>확인</trans>
                        </button>
                        <button class="btn btn-secondary pull-right m-r-10" @click="onModalCancel()">
                            <trans>취소</trans>
                        </button>
                    </div>
                </div>
            </div>
        </vvo>
    </div>
</template>

<script>
import xeBaseSetting from "@src/views/widget/v1/common/xeBaseSetting.js";
import * as rules from "@src/consts/ruleConsts.js";
import backEndApi from "@src/api/backEndApi.js";

export default {
    extends: xeBaseSetting,
    props: ["modalShow"],
    data() {
        return {
            rules,
            systemNodeList: [],
            isLoading: false,
        };
    },
    watch: {
        modalShow: {
            handler(newVal) {
                if (newVal) {
                    this.loadSystemNodeList();
                }
            },
            immediate: true,
        },
    },
    methods: {
        // 트리 데이터에서 nodeType이 "System"인 노드만 재귀적으로 추출
        extractSystemNodes(nodes, result = []) {
            if (!nodes || !Array.isArray(nodes)) return result;


            for (const node of nodes) {
                if (node.sysType === "ENGCSTN" && (node.nodeType === "System" || node.nodeType === "Group")) {
                    result.push({
                        sysNodeIdx: node.sysNodeIdx,
                        text: node.text,
                    });
                }
                // children이 있으면 재귀 탐색
                if (node.children && node.children.length > 0) {
                    this.extractSystemNodes(node.children, result);
                }
            }
            return result;
        },

        async loadSystemNodeList() {
            try {
                // sysNodeIdx가 undefined이면 null로 초기화 (선택안함 기본 선택)
                if (this.copySetting.sysNodeIdx === undefined) {
                    this.$set(this.copySetting, "sysNodeIdx", null);
                }
                // usePrimaryEnergyUnit이 undefined이면 false로 초기화
                if (this.copySetting.useMoneyUnit === undefined) {
                    this.$set(this.copySetting, "useMoneyUnit", true);
                }
                // showSelfSufficiency가 undefined이면 true로 초기화
                if (this.copySetting.showSelfSufficiency === undefined) {
                    this.$set(this.copySetting, "showSelfSufficiency", true);
                }
                // showEnergyConsumption이 undefined이면 true로 초기화
                if (this.copySetting.showEnergyConsumption === undefined) {
                    this.$set(this.copySetting, "showEnergyConsumption", true);
                }

                this.isLoading = true;
                this.systemNodeList = [];

                // 1. 루트 노드 목록 조회
                const rootRes = await backEndApi.sysNode.getRootNodeList("Y");
                if (!rootRes.data || rootRes.data.length === 0) {
                    return;
                }

                // 2. 각 루트 노드의 트리 조회 및 System 노드 추출
                const allSystemNodes = [];
                for (const rootNode of rootRes.data) {
                    try {
                        const treeRes = await backEndApi.sysNode.getSysNodeTree(rootNode.sysNodeIdx);
                        if (treeRes.data) {
                            // 트리 데이터가 배열인지 단일 객체인지 확인
                            const treeData = Array.isArray(treeRes.data) ? treeRes.data : [treeRes.data];
                            const systemNodes = this.extractSystemNodes(treeData);
                            allSystemNodes.push(...systemNodes);
                        }
                    } catch (treeError) {
                        console.error(`트리 조회 실패 (sysNodeIdx: ${rootNode.sysNodeIdx}):`, treeError);
                    }
                }

                this.systemNodeList = allSystemNodes;
            } catch (error) {
                console.error("계통 목록 조회 실패:", error);
            } finally {
                this.isLoading = false;
            }
        },
        async onModalOK() {
            await this.$emit("on-modal-ok", this.copySetting);
        },
    },
};
</script>

<style scoped>
.checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin-bottom: 4px;
}

.checkbox-label input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.checkbox-label span {
    font-size: 14px;
    color: #495057;
}
</style>
